import {
  createStyles, FormHelperText, Grid, makeStyles, TextField, Theme,
} from '@material-ui/core';
import React from 'react';
import { useFormContext, ControllerRenderProps, Controller } from 'react-hook-form';

interface IFormElementWithThreeInput {
    labelInput: string;
    nameInput1: string;
    nameInput2: string;
    nameInput3: string;
}

const FormElementWithThreeInput : React.FC<IFormElementWithThreeInput> = ({
  labelInput,
  nameInput1,
  nameInput2,
  nameInput3,
}) => {
  const { control, errors } = useFormContext();
  const classes = useStyles();
  return (
    <Grid container={true} spacing={2} className={classes.formElementControl}>
      <Grid item={true} xs={12} md={4}>
        <div className={classes.formLabelThreeInput}>
          <p>
            <span>必須</span>
            {labelInput}
          </p>
        </div>
      </Grid>
      <Grid item={true} xs={12} md={8}>
        <div className={classes.threeInputContainer}>
          <div className={classes.inputEl}>
            <Controller
              name={nameInput1}
              control={control}
              render={(
                { ref, onChange, ...rest }: ControllerRenderProps,
              ) => (
                <TextField
                  {...rest}
                  inputRef={ref}
                  onChange={onChange}
                  fullWidth={true}
                  className={classes.formThreeInput}
                  variant="outlined"
                  margin="normal"
                  error={!!errors[`${nameInput1}`]}
                />
              )}
            />
          </div>
          <div className={classes.seperate}>-</div>
          <div className={classes.inputEl}>
            <Controller
              name={nameInput2}
              control={control}
              render={(
                { ref, ...rest }: ControllerRenderProps,
              ) => (
                <TextField
                  {...rest}
                  inputRef={ref}
                  fullWidth={true}
                  className={classes.formThreeInput}
                  variant="outlined"
                  margin="normal"
                  error={!!errors[`${nameInput2}`]}
                />
              )}
            />
          </div>
          <div className={classes.seperate}>-</div>
          <div className={classes.inputEl}>
            <Controller
              name={nameInput3}
              control={control}
              render={(
                { ref, ...rest }: ControllerRenderProps,
              ) => (
                <TextField
                  {...rest}
                  inputRef={ref}
                  fullWidth={true}
                  className={classes.formThreeInput}
                  variant="outlined"
                  margin="normal"
                  error={!!errors[`${nameInput3}`]}
                />
              )}
            />
          </div>
        </div>
        <FormHelperText error={!!errors[`${nameInput1}`] || !!errors[`${nameInput2}`] || !!errors[`${nameInput3}`]}>{errors[`${nameInput1}`]?.message || errors[`${nameInput2}`]?.message || errors[`${nameInput3}`]?.message}</FormHelperText>
      </Grid>
    </Grid>
  );
};


const useStyles = makeStyles((theme: Theme) => createStyles({
  formElementControl: {
    marginBottom: '29px',
    marginLeft: '10px',
    width: 'calc(100% - 55px)',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      width: '100%',
    },
  },
  formLabelThreeInput: {
    backgroundColor: '#EBEBEB',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '37px',
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '26px',
      color: '#1a1a1a',
      letterSpacing: '0.8px',
      fontWeight: 600,
      textAlign: 'center',
      paddingLeft: '12px',
      '& span': {
        fontSize: '14px',
        lineHeight: '21px',
        color: '#ffffff',
        backgroundColor: '#d0111b',
        marginRight: '0.3em',
      },
    },
  },
  formThreeInput: {
    width: '100%',
    // height: '60px',
    margin: 0,
    marginRight: '1em',
    borderRadius: '5px',
    appearance: 'none',
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    letterSpacing: '0.8px',
    [theme.breakpoints.down('sm')]: {
      height: '56px',
    },
  },
  threeInputContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  inputEl: {
    width: '25%',
  },
  seperate: {
    margin: 'auto 5px',
  },
}));
export default FormElementWithThreeInput;
